module.exports = __webpack_public_path__ + "0b6bb6725576b072c5d0b02ecdd1900d.woff2";


//////////////////
// WEBPACK FOOTER
// ./assets/Lato-BoldItalic.woff2
// module id = 989
// module chunks = 0